module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-[50]49.e1e33e2.woff2";